import { render, staticRenderFns } from "./new-questionnaire.vue?vue&type=template&id=a1e21584&scoped=true"
import script from "./new-questionnaire.vue?vue&type=script&lang=js"
export * from "./new-questionnaire.vue?vue&type=script&lang=js"
import style0 from "./new-questionnaire.vue?vue&type=style&index=0&id=a1e21584&prod&lang=scss"
import style1 from "./new-questionnaire.vue?vue&type=style&index=1&id=a1e21584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e21584",
  null
  
)

export default component.exports